namespace GeniuzPOS.InventoryReport {
    export class IcReport07SkuWhsColumns {
        static columnsKey = 'InventoryReport.IcReport07SkuWhs';
    }
}
